import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioUnchecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z",
		fill: "white",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgRadioUnchecked;
